import React from 'react';

import Button from 'b2b-ui-components-lib/lib/components/button';

import './index.scss';

const RetryComponent = ({ onRetryClick }) => {
  return (
    <div className="redirecting_section">
      <div className="content_column">
        <h2 className="redirect_head">Something went wrong</h2>
        <p className="sub_head">Something went wrong at our end! Don’t worry, we’ll retry fetching our servers again.</p>
        <div className="loader_section">
          <div className="steps_view">
            <span className="filler"></span>
          </div>
          Retrying in 5 seconds...
        </div>
        <Button displayName="Retry Now" onClick={onRetryClick} />
      </div>
      <div className="image_column">
        <img src="https://assets.airtel.in/static-assets/b2b-acq-online-ui/retry.svg" alt="Retry" className="experience_image" />
      </div>
    </div>
  );
};

export default RetryComponent;
